import { toast } from "react-toastify"

export const toastSuccess = (msg, containerId = false) =>
  toast.success(msg, { containerId: containerId || "general" })
export const toastInfo = (msg, containerId = false) =>
  toast.info(msg, { containerId: containerId || "general" })
export const toastError = (msg, containerId = false) =>
  toast.error(msg, { containerId: containerId || "general" })
